import { useContext, createContext } from "react"
import { useRouter as useNextRouter, NextRouter } from "next/router"
import webpack from "webpack"

export const TestRouterContext = createContext<any>(null)

const ROUTES_PREFIX = "/pb"
const ROOT_PATH = "/"

export const pageUrl = {
  edit: ({ regionCode, pageSlug }: { regionCode: string; pageSlug: string }) =>
    `${ROUTES_PREFIX}/${regionCode}/${pageSlug}/edit`,
  /**
   * Returns a URL to the page view.
   * @param regionCode
   * @param pageSlug
   * @param timestamp - optional timestamp to bypass cache. It'll add a query param `v` with the timestamp value.
   * @param prefix - whether to prepend the `/pb` routes prefix
   */
  view: ({
    regionCode,
    pageSlug,
    timestamp,
    prefix = true,
  }: {
    regionCode: string
    pageSlug: string
    timestamp?: string
    prefix?: boolean
  }) => {
    const path = prefix
      ? `${ROUTES_PREFIX}/${regionCode}/${pageSlug}`
      : `/${regionCode}/${pageSlug}`
    const queryString = timestamp ? `?v=${timestamp}` : ""

    return path + queryString
  },
}

/**
 * Tiny wrapper around native NextJS useRouter from next/router.
 * It allows for easier testing, especially for Storyshots.
 *
 * If you plan to test component which uses `useRouter` you can wrap
 * it with `<TestRouterContext.Provider value={}>` and provide router
 * value through context provider.
 * @returns router
 */
export const useRouter = () => {
  const router = useNextRouter()
  const testRouter: NextRouter = useContext(TestRouterContext)

  return testRouter || router
}
